import React, { lazy, Suspense } from "react";
import {
	MapTo,
	Container,
	ComponentMapping,
	ContainerState,
} from "@adobe/aem-react-editable-components";
import { ContainerGridProps } from "./ContainerGrid.types";
import { ContainerGridWrapper } from "./ContainerGrid.styles";
import { handleAspectRatio } from "./ContainerGridFunctions";
import { withRangoContainer } from "src/utils/js/rangoContainer";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Spacer from "src/components/Content/v1/Spacer/Spacer";

const LazyBottomImage = lazy(() =>
	import("./ContainerGrid.styles").then((module) => ({
		default: module.BottomImage,
	}))
);

var sliderSettings = {
	dots: true,
	infinite: true,
	speed: 500,
	slidesToShow: 1,
	slidesToScroll: 1,
	arrows: false,
	adaptativeHeight: true,
};
export class ContainerGridComponent extends Container<
	ContainerGridProps,
	ContainerState
> {
	constructor(props: ContainerGridProps) {
		super(props);

		this.state = {
			componentMapping: this.props.componentMapping || ComponentMapping,
		};
	}

	render() {
		const containerGridBody = (
			<>
				<div
					className={`rango-row rango-row-${this.props.columns} ${
						this.props.centerItems ? "rango-row-centered" : ""
					} ${
						this.props.mobileCarousel && !this.props.isInEditor
							? "hideMobile"
							: ""
					}`}
					id={this.props.id}
				>
					{this.childComponents && this.props.columns === "6"
						? this.childComponents.map((item, k) => {
								return (
									<div
										className={
											this.props.columnsTablet
												? `rango-col-md-${
														this.props.columnsTablet
												  } rango-col-lg-${handleAspectRatio(
														this.props.aspectRatio,
														k
												  )}`
												: `rango-col-${handleAspectRatio(
														this.props.aspectRatio,
														k
												  )}`
										}
										key={k}
									>
										{item}
									</div>
								);
						  })
						: null}
					{this.childComponents && this.props.columns !== "6"
						? this.childComponents.map((item, k) => {
								return (
									<div
										className={
											this.props.columnsTablet
												? `rango-col-md-${this.props.columnsTablet} rango-col-lg-${this.props.columns}`
												: `rango-col-${this.props.columns}`
										}
										key={k}
									>
										{item}
									</div>
								);
						  })
						: null}
					{this.placeholderComponent}
				</div>
				{this.props.mobileCarousel &&
				!this.props.isInEditor &&
				this.childComponents ? (
					<Slider {...sliderSettings} className="sliderMobile">
						{this.childComponents.map((child, k) => {
							return (
								<div key={k} className="slide__item__wrapper">
									{child}
								</div>
							);
						})}
					</Slider>
				) : null}
				{this.props.mobile && this.props.tablet && this.props.desktop ? (
					<Suspense
						fallback={
							<Spacer
								mobile={"403"}
								tablet={"403"}
								desktop={"403"}
								isInEditor={false}
								cqPath={""}
							/>
						}
					>
						<LazyBottomImage
							desktop={this.props.desktop}
							tablet={this.props.tablet}
							mobile={this.props.mobile}
						/>
					</Suspense>
				) : null}
			</>
		);

		return (
			<Suspense
				fallback={
					<Spacer
						mobile={"400"}
						tablet={"400"}
						desktop={"400"}
						isInEditor={false}
						cqPath={""}
					/>
				}
			>
				<ContainerGridWrapper
					paddingBlock={this.props.paddingBlock}
					background={this.props.background}
					gap={this.props.gap}
				>
					{withRangoContainer(this.props.rangoContainer, containerGridBody)}
				</ContainerGridWrapper>
			</Suspense>
		);
	}
}

export const ContainerGridEditConfig = {
	emptyLabel: "Container Grid",

	isEmpty: function (props: ContainerGridProps) {
		return !props;
	},
};

MapTo<ContainerGridProps>("alelo/components/structure/container-grid")(
	ContainerGridComponent,
	ContainerGridEditConfig
);
